import { getSiteMapData } from './getSiteMapData';
export async function generateSiteMap(host, channel = 'DEFAULT') {
    const data = await getSiteMapData(channel);
    const nav = [
        ...(data.nav.primary || []),
        ...(data.nav.secondary || []),
    ];
    return `<?xml version="1.0" encoding="UTF-8"?>
   <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
      ${navMapper(host, nav)
        .flat(10)
        .join('')}
     ${data.urls
        .map(({ loc }) => (`
      <url>
        <loc>${`${host}/discover${loc}`}</loc>
      </url>
    `))
        .join('')}
   </urlset>
 `;
}
function navMapper(host, nodes) {
    return nodes.map(({ link, children }) => {
        if (children) {
            return navMapper(host, children);
        }
        if (!link || typeof link !== 'string')
            return;
        let loc = link;
        if (link.startsWith('/')) {
            loc = `${host}${link}`;
        }
        return `
      <url>
        <loc>${loc}</loc>
      </url>
    `;
    });
}
//# sourceMappingURL=generateSiteMap.js.map